import { getUin } from '../user';
import { objectToGetParams, imgReport } from '../util';
import { getUrlParam, getUrlHashName, getUrlPathName } from '../url';
import { isObject, isArray } from '../type';
import { getOSInfoText, getWeixinVer } from '../os';
import { checkTraceidReady, getSessionTraceid, getTraceid } from '../traceUtil';

let elkReportUrl = `${location.protocol}//ft.moneydata.hk/elk/report/?newVersion=1&`;
const oldElkReportUrl = `${location.protocol}//hkwallet.moneydata.hk/fcgi-bin/app/ewallet_bindcard/ewallet_elk_report.fcgi?`;


let businessName = "";
let appEnv = "production";
let seriesNo = 0;
let seqNo = 0;

export function setElkBusinessName(name) {
    businessName = name
}

export function setElkEnv(elkEnv) {
    appEnv = elkEnv
}
/** 对新版ELK做灰度 */
export function setNewElkReportGray(percent){
    const isNewElk = parseInt(Math.random()*100) < percent || getUrlParam('newElk') === '1';
    if(!isNewElk){
        elkReportUrl = oldElkReportUrl;
    }
}

// http://x.code.oa.com/ppd-web/doc/blob/master/elk.md
/**
 * 上报情景：
 * 1.jserror
 * 2.ajax
 * 3.自定义上报
 */
export function elk(params) {
    // 1.格式化
    let elkParams = getELkObj(params);
    checkTraceidReady()
        .then(() => {
            elkParams.traceid = getTraceid(); 
            elkParams.session_traceid = getSessionTraceid() //跟踪id 可跨域
            const formatParams = objectToGetParams(elkParams, false);
            // 2。上报
            const url = `${elkReportUrl}${formatParams}`;
            imgReport(url);
        });
}

export function getELkObj(params = {}) {
    const defaultConfig = getDefaultConfig();
    const reportParams = {};
    Object.keys(defaultConfig).forEach(key => {
        let value = params[key] || defaultConfig[key];
        if (isObject(value) || isArray(value)) {
            value = JSON.stringify(value) || '';
        }
        // url需要encode一下
        // axios的post请求中 body的数据会被json.string 所以这里要encode一下
        if (['url', 'body', 'msg'].indexOf(key) > -1) {
            // 需要encode
            value = encodeURIComponent(value) || '';
        }
        // 优先取传参数据内容，否则取默认配置
        if (value !== '') {
            reportParams[key] = value;
        }
    });
    if (reportParams.str2 === 'ajax' || reportParams.str2 === 'template' || reportParams.str2 === 'jsapi') { //ajax，页面直出数据，jsapi请求  //todo 是否定义一个核心链路的参数
        reportParams.series_no = ++seriesNo;
    }
    reportParams.seq_no = ++seqNo;
    return reportParams;
}

export function checkIsElkReport(url) {
    console.log(elkReportUrl);
    return url === elkReportUrl;
}

export function checkShouldSkipReport(config) {
    let skip = false;
    if (config && config.url) {
        skip = getUrlParam('noreport', config.url) === '1';
    }
    if (config && config.params) {
        skip = config.params.noreport === '1';
    }
    return skip;
}


function getDefaultConfig() {
    const envTag = appEnv === 'production' ? '' : `_${appEnv}`;
    return {
        nodeType: 'ppd_web_hkwallet',
        uin: getUin(),
        errCode: 0,
        channel: `${businessName}${envTag}`,
        key: 'custom',//上报类型 默认为自定义上报
        body: '',
        msg: '',
        str1: '',
        str2: '',
        str3: '',
        str4: '',
        str5: '',
        url: location.href,
        timeDiff: 0,

        method:'',  //区分get或post
        traceid: '', //跟踪id 可跨域
        session_traceid: '', //会话级
        page_hash: getUrlHashName(),
        page_path: getUrlPathName(),
        client_time: new Date().getTime(),  //客户端时间
        series_no: 0,    //关键序列号
        seq_no: 0, //序列号
        system_ver: getOSInfoText(),   //系统版本 eg: iphone 11.0
        weixin_ver: getWeixinVer()    //微信版本 eg: 7.0.12
    };
}
